export default __webpack_public_path__ + "static/media/erica.f93bb7cf.jpg";